import React from 'react'
import { useIntl } from 'react-intl'
import type { FlightsCreditDetails } from 'components/Flights/types'

import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TermsAndConditionsList from './TermsAndConditionsList'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  creditDetails: FlightsCreditDetails
}

function RebookingConditions(props: Props) {
  const intl = useIntl()
  const { creditDetails, creditDetails: { carrierName } } = props

  const headingText = intl.formatMessage(
    {
      id: 'w_aERmF370-EjwNqLx0n',
      defaultMessage: 'Book your new flights with your {carrierName} flight credit',
      description: 'Heading for flight credit rebooking conditions page',
    },
    { carrierName },
  )

  const accessNotice = intl.formatMessage({
    id: 'JMET99h5jQnVc5PWhISz',
    defaultMessage: 'Please note this page is only accessible through the email.',
    description: 'Bold notice that flight credit rebooking page is only accessible via email link',
  })

  const navigationWarning = intl.formatMessage({
    id: 'x8nWC1b6C1pzFPa9eS02',
    defaultMessage: 'You are able to navigate to other areas of Luxury Escapes. However by doing this you will not be able to return to this page. You will need to go back to your email and restart the booking process.',
    description: 'Warning about leaving the flight credit rebooking page',
  })

  const termsIntro = intl.formatMessage({
    id: '1SWjskM5y-M6R5eOKYbi',
    defaultMessage: 'There are additional terms and conditions associated with using these credits to book flights. These include:',
    description: 'Introduction text before the flight credit terms and conditions list',
  })

  return <VerticalSpacer gap={20}>
    <Heading variant="heading3" align="center">
      {headingText}
    </Heading>
    <VerticalSpacer gap={8}>
      <BodyText variant="large" weight="bold">
        {accessNotice}
      </BodyText>
      <BodyText variant="large">
        {navigationWarning}
      </BodyText>
    </VerticalSpacer>
    <BodyText variant="large">
      {termsIntro}
    </BodyText>
    <TermsAndConditionsList {...creditDetails} />
  </VerticalSpacer>
}

export default RebookingConditions
